export const phoneRegex = new RegExp(/^(0) ?\d{10}$/gi)

export const dateStringSlashesRegex = new RegExp(/\d{2}\/\d{2}\/\d{4}/gi)
export const alphabeticRegex = new RegExp(/^[A-Za-z\s]*$/)

export const matchRegexExactly = (string: string, regex: RegExp) => {
  const match = regex.exec(string)
  return match && string === match[0]
}
